import { render, staticRenderFns } from "./AddressBlock.vue?vue&type=template&id=2e1414f8"
import script from "./addressBlock.ts?vue&type=script&lang=js&external"
export * from "./addressBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports